"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textToKebab = exports.statelessFunctionNameToKebab = exports.pascalToKebab = void 0;

var textToKebab = function textToKebab(text) {
  return text.trim().replace(/\s+/g, '-') // Replace spaces with -
  .replace(/[^\w\-]+/g, '') // Remove all non-word chars
  .replace(/\-\-+/g, '-') // Replace multiple - with single -
  .replace(/-$/g, '') // Remove trailing -
  .toLowerCase();
};

exports.textToKebab = textToKebab;

var pascalToKebab = function pascalToKebab(pascal) {
  return pascal.trim().replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2').toLowerCase();
};

exports.pascalToKebab = pascalToKebab;

var statelessFunctionNameToKebab = function statelessFunctionNameToKebab(statelessFunctionName) {
  return textToKebab(statelessFunctionName.split(/(?=[A-Z])/).join(' '));
};

exports.statelessFunctionNameToKebab = statelessFunctionNameToKebab;